import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurycarentalsinpune() {



  const cardData =
  {
    keyword: 'Luxury Cab Rentals in Pune',
    heading: 'Aaryan Travels: Luxury Cab Rentals in Pune',
    headingDescription: 'Aaryan Travels offers premium Luxury Cab Rentals in Pune for corporate executives, VIP guests, weddings, and leisure travelers who seek style and comfort in every journey. Whether it’s an airport transfer from Pune International Airport, a business meeting in Kalyani Nagar, a celebrity pickup in Koregaon Park, or a scenic drive to Mahabaleshwar or Lonavala, our fleet of luxury sedans and high-end SUVs—including Mercedes, BMW, and Innova Crysta—ensures an elite travel experience. With uniformed chauffeurs, plush interiors, and on-request amenities like Wi-Fi and bottled water, we deliver a refined and professional ride across Pune. Aaryan Travels is your trusted partner for chauffeur-driven luxury cab rentals in Pune.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and the former seat of the Maratha Empire. Visitors explore its grand gateways, sprawling lawns, and historic ruins. The evening light-and-sound show vividly narrates the tales of Bajirao and Maratha glory. Despite being partially destroyed by fire, its legacy still stands strong. Shaniwar Wada is Pune’s majestic symbol of heritage and valor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic landmark closely associated with India’s freedom movement. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were interned here during the Quit India Movement. Now a museum, it preserves their personal belongings and photographs. Its Italian arches and lush gardens add to its charm. Aga Khan Palace is Pune’s tribute to sacrifice and peace."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched atop a hill, is famous for the 1670 battle led by Tanaji Malusare for Chhatrapati Shivaji Maharaj. Trekkers hike up to enjoy panoramic views of the Sahyadris, especially during monsoon. Food stalls at the top serve local delicacies like pithla-bhakri. Sinhagad is Pune’s ultimate blend of history, adventure, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes a center of grand celebrations. The peaceful aura leaves every visitor spiritually fulfilled. Dagdusheth Temple is Pune’s divine heart of devotion."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. With its monolithic pillars, stone carvings, and peaceful sanctum, it offers a rare glimpse into ancient Indian architecture. Despite being located in the busy city center, it remains a serene retreat. Pataleshwar is Pune’s hidden cave of calmness."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases over 20,000 artifacts collected by Dr. Dinkar Kelkar, including musical instruments, sculptures, and antique household items. Its recreation of Mastani Mahal is a major attraction. Each exhibit tells a story of India’s cultural richness. The museum is Pune’s treasure chest of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill offers breathtaking views of Pune city after climbing 103 stone steps. At the summit lies the Parvati Temple, built during the Peshwa reign and dedicated to Lord Shiva and Goddess Parvati. Smaller shrines and a museum add to the spiritual ambiance. Sunrises and sunsets from here are mesmerizing. Parvati Hill is Pune’s serene hilltop sanctuary."
  },
  {
    "title": "Osho Ashram (Osho International Meditation Resort)",
    "description": "Located in Koregaon Park, Osho Ashram is a global center for meditation, wellness, and spiritual growth. Spread across lush gardens, it offers various healing therapies and silent spaces for reflection. Visitors from around the world come to rejuvenate their minds. Osho Ashram is Pune’s international retreat of peace and mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Inspired by Japan’s Korakuen Garden, Pu La Deshpande Garden is Pune’s largest landscaped park. It features streams, stone bridges, walking trails, and seasonal flowers. Families enjoy picnics and nature strolls in its calm surroundings. The garden reflects Indo-Japanese harmony. Pu La Deshpande Garden is Pune’s lush green escape."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a scenic reservoir and popular weekend destination near Pune. The tranquil waterbody surrounded by hills becomes especially beautiful during monsoon. Street vendors selling corn and tea enhance the experience. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing lakeside getaway."
  }
],



  "services": [
  {
    "name": "Luxury Cab Rentals in Pune",
    "description": "Luxury Cab Rentals in Pune offer premium chauffeur-driven vehicles for business, leisure, and special occasions. Experience superior comfort, timely service, and professional drivers for all your travel needs."
  },
  {
    "name": "Premium Taxi Services Pune",
    "description": "Premium Taxi Services Pune provide elegant and comfortable rides with high-end vehicles and courteous chauffeurs. Ideal for executives, events, and VIP transportation."
  },
  {
    "name": "Executive Cab Hire Pune",
    "description": "Executive Cab Hire Pune delivers professional and stylish cab solutions for corporate clients. Each ride ensures punctuality, privacy, and comfort for business leaders and professionals."
  },
  {
    "name": "Chauffeur Driven Luxury Pune",
    "description": "Chauffeur Driven Luxury Pune offers sophisticated travel experiences with trained drivers and top-tier cars. Designed for those who value comfort, class, and reliability."
  },
  {
    "name": "Wedding Cab Rentals Pune",
    "description": "Wedding Cab Rentals Pune provide luxury vehicles for wedding ceremonies, guests, and event logistics. Make your special day memorable with elegant rides and impeccable service."
  },
  {
    "name": "Corporate Luxury Cab Pune",
    "description": "Corporate Luxury Cab Pune caters to companies seeking high-end travel for executives and clients. This service ensures punctuality, premium comfort, and a professional experience."
  },
  {
    "name": "Affordable Luxury Cabs Pune",
    "description": "Affordable Luxury Cabs Pune combine elegance with value, offering luxurious rides at competitive prices. Perfect for business, leisure, or special events without exceeding your budget."
  },
  {
    "name": "Best Luxury Taxi Pune",
    "description": "Best Luxury Taxi Pune provides the finest selection of luxury taxis for business meetings, airport transfers, and city tours. Enjoy a seamless and classy travel experience across Pune."
  },
  {
    "name": "Online Luxury Cab Booking Pune",
    "description": "Online Luxury Cab Booking Pune allows easy digital booking for premium cars. With instant confirmations and flexible scheduling, it brings convenience and comfort to your travel planning."
  },
  {
    "name": "Luxury Vehicle Hire Pune",
    "description": "Luxury Vehicle Hire Pune offers a wide range of top-brand cars available for rent. Ideal for executives, weddings, and private use, with full chauffeur support and maintenance."
  },
  {
    "name": "Luxury Sedan Rental Pune",
    "description": "Luxury Sedan Rental Pune provides stylish sedans for those who prefer elegant, smooth, and professional rides. Suitable for corporate and personal use alike."
  },
  {
    "name": "Luxury SUV Rental Pune",
    "description": "Luxury SUV Rental Pune delivers spacious, powerful, and comfortable SUVs for families, executives, and event guests. Experience luxury and versatility combined."
  },
  {
    "name": "Business Class Cab Pune",
    "description": "Business Class Cab Pune is tailored for corporate professionals seeking first-class travel within Pune. Expect punctual service, privacy, and luxury every time you ride."
  },
  {
    "name": "High-End Cab Services Pune",
    "description": "High-End Cab Services Pune ensure elite-level travel with luxury vehicles, courteous chauffeurs, and on-time pickups. Perfect for VIPs, business meetings, and premium transport needs."
  },
  {
    "name": "Elite Car Rentals Pune",
    "description": "Elite Car Rentals Pune offer exclusive high-end vehicles for corporate and personal rentals. Each ride is defined by sophistication, comfort, and exceptional service quality."
  }
],
"tableData": [
  ["Luxury Cab Rentals in Pune", "Premium Taxi Services Pune"],
  ["Executive Cab Hire Pune", "Chauffeur Driven Luxury Pune"],
  ["Wedding Cab Rentals Pune", "Corporate Luxury Cab Pune"],
  ["Affordable Luxury Cabs Pune", "Best Luxury Taxi Pune"],
  ["Online Luxury Cab Booking Pune", "Luxury Vehicle Hire Pune"],
  ["Luxury Sedan Rental Pune", "Luxury SUV Rental Pune"],
  ["Business Class Cab Pune", "High-End Cab Services Pune"],
  ["Elite Car Rentals Pune", "—"]
],




"whychoose": [
  {
    "WhyChooseheading": "Luxury Cab Rentals in Pune",
    "WhyChoosedescription": "Aaryan Travels offers premium luxury cab rentals in Pune, perfect for business executives, VIP guests, and special occasions."
  },
  {
    "WhyChooseheading": "High-End Fleet of Luxury Vehicles",
    "WhyChoosedescription": "Choose from a selection of top-tier luxury cars, including sedans and SUVs, for a first-class travel experience."
  },
  {
    "WhyChooseheading": "Chauffeur-Driven Excellence",
    "WhyChoosedescription": "Our professional and courteous chauffeurs ensure a smooth, stylish, and comfortable ride throughout your journey."
  },
  {
    "WhyChooseheading": "Clean, Sanitized & Well-Maintained Cabs",
    "WhyChoosedescription": "Each luxury vehicle is regularly cleaned and maintained to meet the highest standards of safety and hygiene."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "Enjoy premium service with clear pricing that includes all charges—fuel, tolls, and driver fees—upfront."
  },
  {
    "WhyChooseheading": "24/7 Premium Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, custom requirements, and last-minute changes."
  },
  {
    "WhyChooseheading": "Custom Packages for Events and Business Needs",
    "WhyChoosedescription": "Whether for corporate events, airport transfers, or weddings, our luxury cab plans are tailored to your specific needs."
  },
  {
    "WhyChooseheading": "On-Time Service with Style",
    "WhyChoosedescription": "Experience punctual pickups and drop-offs with luxury and comfort, making every ride memorable."
  }
]

















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer luxury cab rentals in Pune?',
    answer: 'Yes, Aaryan Travels provides premium and comfortable luxury cab rentals in Pune for business, events, and personal travel.',
  },
  {
    question: 'How can I book a luxury cab rental in Pune with Aaryan Travels?',
    answer: 'You can book through our website, mobile app, or by contacting our 24x7 customer support team for luxury cab rentals in Pune.',
  },
  {
    question: 'What types of luxury vehicles are available for rent in Pune?',
    answer: 'Aaryan Travels offers a fleet of high-end sedans, SUVs, and premium cars from top brands for luxury rentals in Pune.',
  },
  {
    question: 'Are the drivers trained for luxury cab services in Pune?',
    answer: 'Absolutely. Our drivers are well-groomed, professionally trained, and experienced in handling luxury cab services in Pune.',
  },
  {
    question: 'Can I rent a luxury cab in Pune for special occasions or events?',
    answer: 'Yes, our luxury cab rentals in Pune are ideal for weddings, corporate events, airport transfers, and VIP travel.',
  },
  {
    question: 'Is the luxury cab rental service in Pune available 24x7?',
    answer: 'Yes, Aaryan Travels offers 24x7 availability for luxury cab rentals in Pune to suit your schedule and needs.',
  },
  {
    question: 'Are safety and hygiene standards maintained in luxury cabs?',
    answer: 'All luxury vehicles are sanitized before every ride, and we follow strict safety and hygiene protocols for your peace of mind.',
  },
  {
    question: 'What payment methods are accepted for luxury cab rentals in Pune?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts for luxury cab bookings.',
  },
  {
    question: 'Can I schedule a luxury cab in advance in Pune?',
    answer: 'Yes, you can pre-book luxury cab rentals in Pune to ensure timely and hassle-free service for your travel plans.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Deshmukh',
    feedback: 'Aaryan Travels delivered an outstanding luxury cab rental experience in Pune. The vehicle was spotless and the driver was highly professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Shah',
    feedback: 'Booked a luxury cab in Pune with Aaryan Travels for a corporate event — seamless service, punctuality, and total comfort!',
    rating: 5,
  },
];



















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const luxuryCabRentalsPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Luxury Cab Rentals in Pune",
  "description": "Aaryan Travels offers premium luxury cab rentals in Pune including chauffeur-driven luxury cars for weddings, corporate travel, business class rides, and more.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": "Luxury Cab Rentals",
  "keywords": "Luxury Cab Rentals in Pune, Premium Taxi Services Pune, Executive Cab Hire Pune, Chauffeur Driven Luxury Pune, Wedding Cab Rentals Pune, Corporate Luxury Cab Pune, Affordable Luxury Cabs Pune, Best Luxury Taxi Pune, Online Luxury Cab Booking Pune, Luxury Vehicle Hire Pune, Luxury Sedan Rental Pune, Luxury SUV Rental Pune, Business Class Cab Pune, High-End Cab Services Pune, Elite Car Rentals Pune"
};






  return (
    <div>
<Helmet>
  <title>Luxury Cab Rentals in Pune | Premium & Chauffeur Driven Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Book luxury cab rentals in Pune with Aaryan Travels. Chauffeur driven premium taxis for weddings, corporate events, and business travel."
  />
  <meta
    name="keywords"
    content="Luxury Cab Rentals in Pune, Premium Taxi Services Pune, Executive Cab Hire Pune, Chauffeur Driven Luxury Pune, Wedding Cab Rentals Pune, Corporate Luxury Cab Pune, Affordable Luxury Cabs Pune, Best Luxury Taxi Pune, Online Luxury Cab Booking Pune, Luxury Vehicle Hire Pune, Luxury Sedan Rental Pune, Luxury SUV Rental Pune, Business Class Cab Pune, High-End Cab Services Pune, Elite Car Rentals Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(luxuryCabRentalsPuneSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/72.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurycarentalsinpune;